import React from "react";
import { Button } from "react-bootstrap";

const LoadingButton = ({ isLoading, children, ...props}) => {
  return (
    <Button disabled={isLoading} {...props}>
      { isLoading 
        ? (
          <div className="spinner-border spinner-border-sm text-light" role="status">
            <span className="sr-only">Loading</span>
          </div>
          )
          : children}
    </Button>
  );
};

export default LoadingButton;
